import { Control, Controller } from "react-hook-form";

import { useBidWorkflow } from "../../../lib/hooks/api/bid/bids/useBidWorkflow";
import { GroupedStageOptions } from "../../shared/stage/types";
import { processTransitions } from "../../shared/stage/utils";
import { WorfklowStageCheckboxList } from "../../shared/stage/WorfklowStageCheckboxList";
import { BidFilters } from "../utils";

type BidStageCheckboxSelectProps = {
  control: Control<BidFilters, unknown>;
};

export function BidStageCheckboxSelect({ control }: BidStageCheckboxSelectProps) {
  const { data } = useBidWorkflow();

  const options: GroupedStageOptions[] = data ? processTransitions(data.transitions) : [];

  return (
    <div aria-label="Bid stage filters">
      <Controller
        name="stageIds"
        control={control}
        render={({ field }) => (
          <WorfklowStageCheckboxList
            {...field}
            stageGroups={options}
            checkedStageIds={field.value ?? []}
          />
        )}
      />
    </div>
  );
}
